import ApiResponse from "src/interfaces/ApiResponse";
import api from "./api";
import { CategoriasCadastroDto } from "src/pages/Privada/Estoque/Categorias/Cadastro/CategoriasCadastro.Dto";
import { CategoriasFiltrarDto } from "src/pages/Privada/Estoque/Categorias/Categorias.Dto";
import { ProdutoCadastroDto } from "src/pages/Privada/Estoque/Produto/Cadastro/ProdutoCadastro.Dto";
import { ProdutoFiltrarDto } from "src/pages/Privada/Estoque/Produto/Produto.Dto";

export function CategoriaBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE +
      "/categoria/buscar-por-id?id=" +
      id
  );
}

export function CategoriaIncluir(categoria: CategoriasCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/categoria/incluir",
    categoria
  );
}

export function CategoriaAtualizar(categoria: CategoriasCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/categoria/atualizar",
    categoria
  );
}

export function CategoriaBuscarTodos() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/categoria/buscar-todos"
  );
}

export function CategoriaFiltrar(input: CategoriasFiltrarDto) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/categoria/filtrar",
    {
      params: input,
    }
  );
}

export function ProdutoIncluir(input: ProdutoCadastroDto) {
  return api.post<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/produto/incluir",
    input
  );
}

export function ProdutoAtualizar(input: ProdutoCadastroDto) {
  return api.put<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/produto/atualizar",
    input
  );
}

export function ProdutoFiltrar(input: ProdutoFiltrarDto) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE + "/produto/filtrar",
    {
      params: input,
    }
  );
}

export function ProdutoBuscarPorId(id: string) {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_ESTOQUE +
      "/produto/buscar-por-id?id=" +
      id
  );
}
